import { logError, sleep } from '../../../../lib/utils';
import { ICloseableDialogProps } from '../../../_core/core.types';
import { resetFormMessages } from '../../../_core/form/form.helpers';
import { IFormWithStepperProps } from '../../../_core/form/form.types';
import { useCreateDepartments } from '../department.service';
import { ICreateDepartmentProps } from '../department.types';
import { CreateDepartmentsForm } from './create-departments-form.component';

interface ICreateDepartmentsNestedContainerProps extends IFormWithStepperProps, ICloseableDialogProps {
  ignoreDefaults?: boolean;
}

export const CreateDepartmentsNestedContainer = ({
  close,
  ignoreDefaults,
  onError,
  onSuccess,
  ...rest
}: ICreateDepartmentsNestedContainerProps) => {
  const { createDepartments } = useCreateDepartments();

  const handleSubmit = async (props: ICreateDepartmentProps) => {
    try {
      await resetFormMessages({ setSubmitError: onError, setSuccess: onSuccess });

      await createDepartments(props);
      onSuccess?.('Successfully created departments');

      await sleep(250);
      close();
    } catch (err) {
      const errMsg = 'Unable to create departments.';
      logError(errMsg, (err as Error).message);
      onError?.(errMsg);
    }
  };

  return <CreateDepartmentsForm ignoreDefaults={ignoreDefaults} onSubmit={handleSubmit} {...rest} />;
};
